import BaseStore from '@/store/base-store'

const options = {
  actions: {
    clear ({ commit }) {
      commit('item', {})
    }
  }
}
export default new BaseStore('customers', options)



// WEBPACK FOOTER //
// ./src/store/modules/customers.store.js